var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['banner-done', _vm.className]},[_c('div',{attrs:{"id":"yandex_rtb_R-A-292666-1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }